import { render, staticRenderFns } from "./WorldHeadbar.vue?vue&type=template&id=4961fa1e&scoped=true&"
import script from "./WorldHeadbar.vue?vue&type=script&lang=js&"
export * from "./WorldHeadbar.vue?vue&type=script&lang=js&"
import style0 from "./WorldHeadbar.vue?vue&type=style&index=0&id=4961fa1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961fa1e",
  null
  
)

export default component.exports